var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3501 9.10771L8.62283 1.60771C8.99951 1.21925 9.51753 1 10.0586 1H11.2747C13.0417 1 13.9406 3.12375 12.7105 4.39229L8.13798 9.10771C7.38571 9.88348 7.38571 11.1165 8.13798 11.8923L12.7105 16.6077C13.9406 17.8762 13.0417 20 11.2747 20H10.0586C9.51753 20 8.99951 19.7808 8.62283 19.3923L1.3501 11.8923C0.597835 11.1165 0.597836 9.88348 1.3501 9.10771Z",
    stroke: "#2C3038"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back.e64a0b26949d7009463c2dffa063a5cb.svg";